import React from 'react';
import { Loader2 } from 'lucide-react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@roger/ui-components';

interface DeleteAssessmentDialogProps {
  open: boolean;
  isDeleting: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const DeleteAssessmentDialog: React.FC<DeleteAssessmentDialogProps> = ({
  open,
  isDeleting,
  onConfirm,
  onClose,
}) => {
  return (
    <Dialog open={open} onOpenChange={open => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Assessment</DialogTitle>
        </DialogHeader>
        <p className='text-sm text-muted-foreground'>
          Are you sure you want to delete this assessment? This action cannot be
          undone.
        </p>
        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            variant='destructive'
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting && <Loader2 className='h-4 w-4 mr-1 animate-spin' />}
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteAssessmentDialog;
